export class Afiliado 
{
    constructor(    public id?: number, 
                    public nombres?: string,
                    public apellidoMaterno?: string,
                    public apellidoPaterno?: string,
                    public rut?: string,
                    public email?: string,
                    public direccion?: string,
                    public numero?: string,
                    public telefonoFijo?: string,
                    public telefonoMovil?: string,
                    public fechaNacimiento?: any,
                    public fechaAfiliado?: any,
                    public cargas?: any,
                    public sexo?: any,
                    public idSexo?: any,    
                    public idNacionalidad?: any,   
                    public idEstadoCivil?: any, 
                    public idSistemaSalud?: any,                     
                    public dv?: string,
                    public parentesco?: string,                   
                    public fechaAfiliacion?: string,
                    public fechaDesafiliacion?: string,                    
                    public grado?: string,
                    public calidadJuridica?: string,
                    public fechaCalidadJuridica?: any,         
                    public programaPresupuestario?: string,
                    public estamento?: string,
                    public fechaInicioGrado?: any,
                    public fechaCargo?: any,
                    public numResolucion?: string,
                    public fechaResolucion?: any,
                    public asociadoA?: string,
                    public funcionRealizada?: string,
                    public bancoCodigo?: string,
                    public idBanco?: any,                    
                    public tipoCuentaCodigo?: string,
                    public numeroCuenta?: string,
                    public montoPension?: string,
                    public bancos?: any,
                    public tipoCuentas?: any,   
                    public nacionalidades?: any,  
                    public tiposPensiones?: any,    
                    public tipoPension?: any,    
                    public entidadesPensiones?: any,  
                    public entidadPension?: any,     
                    public modalidadesPensiones?: any,  
                    public modalidadPension?: any,                      
                    public estadoCivil?: any,        
                    public sistemaSalud?: any,                          
                    public regiones?: any,
                    public comunas?: any,
                    public idRegion?: any,
                    public idComuna?: any,
                    public descripcionAdicional?: string,
                    public emailPersonal?: string,
                    public estadoAfiliado?: string,
                    public tipoAfiliado?: string,                    
                    public deshabilitado?: boolean,
                    public fechaDeshabilitada?: boolean,                    
                    public isAdmin?: boolean,
                    public observacion?: string,
                    public documentos?: any
    ) {  }
}   



